<div
  [class.container]="isVerticalLayout$ | async"
  class="flex items-center w-full toolbar px-gutter"
  >
  <button
    (click)="openSidenav()"
    [class.hidden]="!mobileQuery"
    mat-icon-button
    type="button"
    >
    <mat-icon svgIcon="mat:menu"></mat-icon>
  </button>
  <button
    (click)="toggleCollapse()"
    class="w-14 h-14 p-0 leading-none hidden lg:!flex items-center justify-center"
    mat-icon-button
    type="button"
    >
    @if (!collapsed) {
      <mat-icon
        class="w-6 h-6"
        svgIcon="mat:radio_button_checked"
      ></mat-icon>
    }
    @if (collapsed) {
      <mat-icon
        class="w-6 h-6"
        svgIcon="mat:radio_button_unchecked"
      ></mat-icon>
    }
  </button>

  @if (isVerticalLayout$ | async) {
    <a
      [routerLink]="['/']"
      class="flex items-center block ltr:mr-4 rtl:ml-4"
      >
      <img alt="Logo" class="w-8 select-none" src="assets/img/demo/logo.svg" />
      <h1
        [class.hidden]="!mobileQuery"
        class="m-0 select-none title ltr:pl-4 rtl:pr-4"
        >
        VEX
      </h1>
    </a>
  }

  @if ((isVerticalLayout$ | async) && isNavbarInToolbar$ | async) {
    <div
      [class.hidden]="mobileQuery"
      class="flex items-center flex-none px-gutter"
      >
      @for (item of navigationItems; track item) {
        <vex-navigation-item
          [item]="item"
        ></vex-navigation-item>
      }
    </div>
  }

  <span class="flex-1"></span>

  <div class="flex items-center -mx-1"></div>
</div>

@if ((isVerticalLayout$ | async) && isNavbarBelowToolbar$ | async) {
  <vex-navigation
    [class.hidden]="mobileQuery"
  ></vex-navigation>
}
